import { CompletionStatus } from './mentoring-program-enrollments';

export enum MentoringProgramGuideRole {
  MENTOR = 'mentor',
  MENTEE = 'mentee',
  MENTOR_AND_MENTEE = 'mentor_and_mentee',
}

export enum MentoringProgramGuideRequirementType {
  MILESTONE = 'milestone',
  SESSION = 'session',
  CONNECTION_SESSION = 'connection_session',
  // Currently, the only "event" is "My Goals"
  // Either way, this seems like maybe it should have a better name
  EVENT = 'event',
}

export enum MentoringProgramMilestone {
  PROFILE_COMPLETION = 'profile_completion',
  PROFILE_REVIEW = 'profile_review',
}

export enum MentoringProgramEvent {
  MY_GOALS = 'my_goals',
}

export type ProfileCompletionCriteria = {
  // Note: This might seem confusing, but "profile_review" is
  // what backend has requested. We still call it "profile completion" in the UI.
  // The 'profile_completion' value is never used yet.
  state: MentoringProgramMilestone.PROFILE_REVIEW;
  status: CompletionStatus.COMPLETED;
};

export type SessionSequenceCriteria = {
  sequence: number[];
};

export type ConnectionSessionCriteria = {
  upperLimit: number;
};

// TODO: This should maybe be renamed
export type MyGoalsCriteria = {
  trigger: MentoringProgramEvent.MY_GOALS;
};

export type MentoringProgramGuideCriteria =
  | ProfileCompletionCriteria
  | SessionSequenceCriteria
  | ConnectionSessionCriteria
  | MyGoalsCriteria;

export type MentoringProgramGuideRequirement = {
  id: number;
  type: MentoringProgramGuideRequirementType;
  criteria: MentoringProgramGuideCriteria;
};

export type MentoringProgramGuideContent = {
  fileName: string;
  fileSize: number;
  fileType: string;
  id: number;
  thumbnailUrl?: string;
  uniqueId: string;
  url: string;
};

export type MentoringProgramGuide = {
  id: number;
  title: string;
  content: string;
  role: MentoringProgramGuideRole;
  mentorshipProgramGuideRequirement: MentoringProgramGuideRequirement;
  video: MentoringProgramGuideContent;
  attachments: MentoringProgramGuideContent[];
};
